import { render, staticRenderFns } from "./CopyrightAmendmentApplicationDetails.vue?vue&type=template&id=6dd5fe8c&scoped=true&"
import script from "./CopyrightAmendmentApplicationDetails.vue?vue&type=script&lang=js&"
export * from "./CopyrightAmendmentApplicationDetails.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightAmendmentApplicationDetails.vue?vue&type=style&index=0&id=6dd5fe8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd5fe8c",
  null
  
)

export default component.exports